import { alpha } from "@mui/material/styles";
import {
  Box,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  CardActionArea,
  FormControlLabel,
} from "@mui/material";
// hooks
import useSettings from "../../hooks/useSettings";

// ----------------------------------------------------------------------

export default function SettingColor() {
  const { themeColor, onChangeColor, colorOption } = useSettings();

  return (
    <RadioGroup
      name="themeColor"
      value={themeColor}
      onChange={onChangeColor}
    ></RadioGroup>
  );
}
